import { GridFilter, GridFilterGroup } from "@hermes/states/grid-filters-state";

/**
 * return the highest price from the presentation filter group
 */
export const getHighestPrice = (filterSlider: GridFilterGroup): number =>
    filterSlider.filters.reduce(
        (accumulator: number, filter: GridFilter) =>
            Number.parseInt(filter.value, 10) >= accumulator
                ? Number.parseInt(filter.value, 10)
                : accumulator,
        0,
    );

/**
 * return the lowest price from the presentation filter group
 */
export const getLowestPrice = (filterSlider: GridFilterGroup): number =>
    filterSlider.filters.reduce(
        (min: number, filter: GridFilter) =>
            Number.parseInt(filter.value, 10) < min
                ? Number.parseInt(filter.value, 10)
                : min,
        // starting at first value index
        Number.parseInt(filterSlider.filters[0].value, 10),
    );
